// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  box-sizing:border-box;
  font-family:'Outfit',sans-serif;
}

/* OVERLAY */

.hotlist_form_overlay{
  position:fixed;
  inset:0;

  background:rgba(15,23,42,.55);

  backdrop-filter:blur(6px);

  display:flex;
  justify-content:center;
  align-items:center;

  z-index:9999;
}

/* MODAL */

.hotlist_form_modal{
  width:70%;
  max-width:850px;

  height:75vh;

  overflow-y:auto;

  background:#fff;

  border-radius:18px;

  box-shadow:
  0 25px 70px rgba(0,0,0,.18);

  animation:hotlist_popup_show .25s ease;
}

/* HEADER */

.hotlist_form_header{
  display:flex;

  justify-content:space-between;

  align-items:center;

  padding:18px 25px;

  border-bottom:1px solid #edf2f7;

  background:white;

  position:sticky;

  top:0;

  z-index:20;
}

.hotlist_form_title{
  font-size:24px;
  font-weight:700;
  color:#111827;
}

.hotlist_form_close_btn{
  width:38px;
  height:38px;

  border:none;

  border-radius:50%;

  background:#f3f4f6;

  cursor:pointer;

  font-size:18px;

  transition:.3s;
}

.hotlist_form_close_btn:hover{
  background:#ef4444;
  color:white;
}

/* FORM GRID */

.hotlist_form_grid{
  padding:22px;

  display:grid;

  grid-template-columns:
  repeat(3,1fr);

  gap:18px;
}

/* FIELD */

.hotlist_form_group{
  display:flex;
  flex-direction:column;
}

.hotlist_form_label{
  font-size:13px;
  font-weight:600;

  color:#374151;

  margin-bottom:6px;
}

.hotlist_form_input,
.hotlist_form_select{
  height:42px;

  border:1px solid #dbe2ea;

  border-radius:10px;

  padding:0 12px;

  font-size:14px;

  background:#fafafa;

  transition:.3s;
}

.hotlist_form_input:focus,
.hotlist_form_select:focus{
  outline:none;

  background:white;

  border-color:#2563eb;

  box-shadow:
  0 0 0 4px rgba(37,99,235,.08);
}

/* REMARKS */

.hotlist_form_remarks_wrapper{
  padding:0 22px 20px;
}

.hotlist_form_textarea{
  width:100%;

  height:90px;

  border:1px solid #dbe2ea;

  border-radius:10px;

  padding:12px;

  resize:none;

  background:#fafafa;
}

.hotlist_form_textarea:focus{
  outline:none;
  border-color:#2563eb;
  background:white;
}

/* UPLOADS */

.hotlist_form_upload_section{
  padding:0 22px 20px;
}

.hotlist_form_upload_row{
  display:flex;

  align-items:center;

  margin-bottom:10px;
}

.hotlist_form_upload_label{
  width:160px;

  padding:10px 14px;

  background:#f8fafc;

  border:1px solid #dbe2ea;

  border-right:none;

  border-radius:10px 0 0 10px;

  font-size:14px;

  font-weight:600;
}

.hotlist_form_file_input{
  flex:1 1;

  border:1px solid #dbe2ea;

  padding:8px;

  border-radius:0 10px 10px 0;
}

/* BUTTONS */

.hotlist_form_button_section{
  display:flex;

  justify-content:flex-end;

  gap:12px;

  padding:18px 22px;

  border-top:1px solid #edf2f7;

  background:white;

  position:sticky;

  bottom:0;
}

.hotlist_form_save_btn{
  min-width:120px;
  height:42px;

  border:none;

  border-radius:10px;

  background:#2563eb;

  color:white;

  font-weight:600;

  cursor:pointer;
}

.hotlist_form_save_btn:hover{
  background:#1d4ed8;
}

.hotlist_form_cancel_btn{
  min-width:120px;
  height:42px;

  border:none;

  border-radius:10px;

  background:#e5e7eb;

  color:#111827;

  font-weight:600;

  cursor:pointer;
}

.hotlist_form_cancel_btn:hover{
  background:#d1d5db;
}

/* SCROLLBAR */

.hotlist_form_modal::-webkit-scrollbar{
  width:8px;
}

.hotlist_form_modal::-webkit-scrollbar-thumb{
  background:#2563eb;
  border-radius:20px;
}

/* ANIMATION */

@keyframes hotlist_popup_show{
  from{
    opacity:0;
    transform:scale(.95);
  }

  to{
    opacity:1;
    transform:scale(1);
  }
}

/* MOBILE */

@media(max-width:768px){

  .hotlist_form_modal{
    width:95%;
    height:90vh;
  }

  .hotlist_form_grid{
    grid-template-columns:1fr;
  }

  .hotlist_form_upload_row{
    flex-direction:column;
    align-items:stretch;
  }

  .hotlist_form_upload_label{
    width:100%;
    border-right:1px solid #dbe2ea;
    border-radius:10px 10px 0 0;
  }

  .hotlist_form_file_input{
    border-radius:0 0 10px 10px;
  }
}
.hotlist_form_upload_section{
  padding:0 22px 20px;

  display:grid;

  grid-template-columns:
  repeat(2,1fr);

  gap:16px;
}

/* DOTTED CARD */

.hotlist_form_upload_card{

  min-height:80px;

  border:2px dashed #dbe2ea;

  border-radius:14px;

  background:#fafafa;

  display:flex;

  align-items:center;

  justify-content:center;

  transition:.3s;

  cursor:pointer;
}

.hotlist_form_upload_card:hover{

  border-color:#2563eb;

  background:#f8fbff;

  transform:translateY(-2px);
}

/* TEXT */

.hotlist_form_upload_text{

  color:#2563eb;

  font-size:14px;

  font-weight:600;

  cursor:pointer;
}

/* HIDE DEFAULT FILE INPUT */

.hotlist_form_hidden_file{
  display:none;
}
.hotlist_form_upload_section{
  padding:0 22px 20px;

  display:grid;

  grid-template-columns:
  repeat(2,1fr);

  gap:16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/newhotlistform.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,YAAY;;AAEZ;EACE,cAAc;EACd,OAAO;;EAEP,6BAA6B;;EAE7B,yBAAyB;;EAEzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;;EAElB,YAAY;AACd;;AAEA,UAAU;;AAEV;EACE,SAAS;EACT,eAAe;;EAEf,WAAW;;EAEX,eAAe;;EAEf,eAAe;;EAEf,kBAAkB;;EAElB;6BAC2B;;EAE3B,sCAAsC;AACxC;;AAEA,WAAW;;AAEX;EACE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,iBAAiB;;EAEjB,+BAA+B;;EAE/B,gBAAgB;;EAEhB,eAAe;;EAEf,KAAK;;EAEL,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;;EAEX,WAAW;;EAEX,iBAAiB;;EAEjB,kBAAkB;;EAElB,cAAc;;EAEd,cAAc;;EAEd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,cAAc;;AAEd;EACE,YAAY;;EAEZ,YAAY;;EAEZ;eACa;;EAEb,QAAQ;AACV;;AAEA,UAAU;;AAEV;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,aAAa;;EAEb,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;;EAEX,wBAAwB;;EAExB,kBAAkB;;EAElB,cAAc;;EAEd,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;;EAEE,YAAY;;EAEZ,gBAAgB;;EAEhB,oBAAoB;;EAEpB;+BAC6B;AAC/B;;AAEA,YAAY;;AAEZ;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;;EAEV,WAAW;;EAEX,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ,WAAW;;EAEX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,YAAY;;AAEZ;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;;EAEZ,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;EACE,WAAW;;EAEX,iBAAiB;;EAEjB,kBAAkB;;EAElB,wBAAwB;;EAExB,iBAAiB;;EAEjB,2BAA2B;;EAE3B,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,QAAM;;EAEN,wBAAwB;;EAExB,WAAW;;EAEX,2BAA2B;AAC7B;;AAEA,YAAY;;AAEZ;EACE,YAAY;;EAEZ,wBAAwB;;EAExB,QAAQ;;EAER,iBAAiB;;EAEjB,4BAA4B;;EAE5B,gBAAgB;;EAEhB,eAAe;;EAEf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;;EAEX,WAAW;;EAEX,kBAAkB;;EAElB,kBAAkB;;EAElB,WAAW;;EAEX,eAAe;;EAEf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;;EAEX,WAAW;;EAEX,kBAAkB;;EAElB,kBAAkB;;EAElB,aAAa;;EAEb,eAAe;;EAEf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;;AAEd;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,cAAc;;AAEd;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA,WAAW;;AAEX;;EAEE;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,mBAAmB;;EAEnB,YAAY;;EAEZ;eACa;;EAEb,QAAQ;AACV;;AAEA,gBAAgB;;AAEhB;;EAEE,eAAe;;EAEf,yBAAyB;;EAEzB,kBAAkB;;EAElB,kBAAkB;;EAElB,YAAY;;EAEZ,kBAAkB;;EAElB,sBAAsB;;EAEtB,cAAc;;EAEd,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;;EAEpB,kBAAkB;;EAElB,0BAA0B;AAC5B;;AAEA,SAAS;;AAET;;EAEE,aAAa;;EAEb,cAAc;;EAEd,eAAe;;EAEf,cAAc;AAChB;;AAEA,4BAA4B;;AAE5B;EACE,YAAY;AACd;AACA;EACE,mBAAmB;;EAEnB,YAAY;;EAEZ;eACa;;EAEb,QAAQ;AACV","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');\n\n*{\n  box-sizing:border-box;\n  font-family:'Outfit',sans-serif;\n}\n\n/* OVERLAY */\n\n.hotlist_form_overlay{\n  position:fixed;\n  inset:0;\n\n  background:rgba(15,23,42,.55);\n\n  backdrop-filter:blur(6px);\n\n  display:flex;\n  justify-content:center;\n  align-items:center;\n\n  z-index:9999;\n}\n\n/* MODAL */\n\n.hotlist_form_modal{\n  width:70%;\n  max-width:850px;\n\n  height:75vh;\n\n  overflow-y:auto;\n\n  background:#fff;\n\n  border-radius:18px;\n\n  box-shadow:\n  0 25px 70px rgba(0,0,0,.18);\n\n  animation:hotlist_popup_show .25s ease;\n}\n\n/* HEADER */\n\n.hotlist_form_header{\n  display:flex;\n\n  justify-content:space-between;\n\n  align-items:center;\n\n  padding:18px 25px;\n\n  border-bottom:1px solid #edf2f7;\n\n  background:white;\n\n  position:sticky;\n\n  top:0;\n\n  z-index:20;\n}\n\n.hotlist_form_title{\n  font-size:24px;\n  font-weight:700;\n  color:#111827;\n}\n\n.hotlist_form_close_btn{\n  width:38px;\n  height:38px;\n\n  border:none;\n\n  border-radius:50%;\n\n  background:#f3f4f6;\n\n  cursor:pointer;\n\n  font-size:18px;\n\n  transition:.3s;\n}\n\n.hotlist_form_close_btn:hover{\n  background:#ef4444;\n  color:white;\n}\n\n/* FORM GRID */\n\n.hotlist_form_grid{\n  padding:22px;\n\n  display:grid;\n\n  grid-template-columns:\n  repeat(3,1fr);\n\n  gap:18px;\n}\n\n/* FIELD */\n\n.hotlist_form_group{\n  display:flex;\n  flex-direction:column;\n}\n\n.hotlist_form_label{\n  font-size:13px;\n  font-weight:600;\n\n  color:#374151;\n\n  margin-bottom:6px;\n}\n\n.hotlist_form_input,\n.hotlist_form_select{\n  height:42px;\n\n  border:1px solid #dbe2ea;\n\n  border-radius:10px;\n\n  padding:0 12px;\n\n  font-size:14px;\n\n  background:#fafafa;\n\n  transition:.3s;\n}\n\n.hotlist_form_input:focus,\n.hotlist_form_select:focus{\n  outline:none;\n\n  background:white;\n\n  border-color:#2563eb;\n\n  box-shadow:\n  0 0 0 4px rgba(37,99,235,.08);\n}\n\n/* REMARKS */\n\n.hotlist_form_remarks_wrapper{\n  padding:0 22px 20px;\n}\n\n.hotlist_form_textarea{\n  width:100%;\n\n  height:90px;\n\n  border:1px solid #dbe2ea;\n\n  border-radius:10px;\n\n  padding:12px;\n\n  resize:none;\n\n  background:#fafafa;\n}\n\n.hotlist_form_textarea:focus{\n  outline:none;\n  border-color:#2563eb;\n  background:white;\n}\n\n/* UPLOADS */\n\n.hotlist_form_upload_section{\n  padding:0 22px 20px;\n}\n\n.hotlist_form_upload_row{\n  display:flex;\n\n  align-items:center;\n\n  margin-bottom:10px;\n}\n\n.hotlist_form_upload_label{\n  width:160px;\n\n  padding:10px 14px;\n\n  background:#f8fafc;\n\n  border:1px solid #dbe2ea;\n\n  border-right:none;\n\n  border-radius:10px 0 0 10px;\n\n  font-size:14px;\n\n  font-weight:600;\n}\n\n.hotlist_form_file_input{\n  flex:1;\n\n  border:1px solid #dbe2ea;\n\n  padding:8px;\n\n  border-radius:0 10px 10px 0;\n}\n\n/* BUTTONS */\n\n.hotlist_form_button_section{\n  display:flex;\n\n  justify-content:flex-end;\n\n  gap:12px;\n\n  padding:18px 22px;\n\n  border-top:1px solid #edf2f7;\n\n  background:white;\n\n  position:sticky;\n\n  bottom:0;\n}\n\n.hotlist_form_save_btn{\n  min-width:120px;\n  height:42px;\n\n  border:none;\n\n  border-radius:10px;\n\n  background:#2563eb;\n\n  color:white;\n\n  font-weight:600;\n\n  cursor:pointer;\n}\n\n.hotlist_form_save_btn:hover{\n  background:#1d4ed8;\n}\n\n.hotlist_form_cancel_btn{\n  min-width:120px;\n  height:42px;\n\n  border:none;\n\n  border-radius:10px;\n\n  background:#e5e7eb;\n\n  color:#111827;\n\n  font-weight:600;\n\n  cursor:pointer;\n}\n\n.hotlist_form_cancel_btn:hover{\n  background:#d1d5db;\n}\n\n/* SCROLLBAR */\n\n.hotlist_form_modal::-webkit-scrollbar{\n  width:8px;\n}\n\n.hotlist_form_modal::-webkit-scrollbar-thumb{\n  background:#2563eb;\n  border-radius:20px;\n}\n\n/* ANIMATION */\n\n@keyframes hotlist_popup_show{\n  from{\n    opacity:0;\n    transform:scale(.95);\n  }\n\n  to{\n    opacity:1;\n    transform:scale(1);\n  }\n}\n\n/* MOBILE */\n\n@media(max-width:768px){\n\n  .hotlist_form_modal{\n    width:95%;\n    height:90vh;\n  }\n\n  .hotlist_form_grid{\n    grid-template-columns:1fr;\n  }\n\n  .hotlist_form_upload_row{\n    flex-direction:column;\n    align-items:stretch;\n  }\n\n  .hotlist_form_upload_label{\n    width:100%;\n    border-right:1px solid #dbe2ea;\n    border-radius:10px 10px 0 0;\n  }\n\n  .hotlist_form_file_input{\n    border-radius:0 0 10px 10px;\n  }\n}\n.hotlist_form_upload_section{\n  padding:0 22px 20px;\n\n  display:grid;\n\n  grid-template-columns:\n  repeat(2,1fr);\n\n  gap:16px;\n}\n\n/* DOTTED CARD */\n\n.hotlist_form_upload_card{\n\n  min-height:80px;\n\n  border:2px dashed #dbe2ea;\n\n  border-radius:14px;\n\n  background:#fafafa;\n\n  display:flex;\n\n  align-items:center;\n\n  justify-content:center;\n\n  transition:.3s;\n\n  cursor:pointer;\n}\n\n.hotlist_form_upload_card:hover{\n\n  border-color:#2563eb;\n\n  background:#f8fbff;\n\n  transform:translateY(-2px);\n}\n\n/* TEXT */\n\n.hotlist_form_upload_text{\n\n  color:#2563eb;\n\n  font-size:14px;\n\n  font-weight:600;\n\n  cursor:pointer;\n}\n\n/* HIDE DEFAULT FILE INPUT */\n\n.hotlist_form_hidden_file{\n  display:none;\n}\n.hotlist_form_upload_section{\n  padding:0 22px 20px;\n\n  display:grid;\n\n  grid-template-columns:\n  repeat(2,1fr);\n\n  gap:16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
